import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import TextInput from "components/Input/TextInput.js";
import { FormControlLabel } from "@mui/material";
import { AddCircleOutline } from "@mui/icons-material";
import { RemoveCircleOutline } from "@mui/icons-material";
import {
  CustomSelect,
  DateInput,
} from "components/Input/Index.js";
import AutocompleteTagsInput from "components/Input/AutocompleteTagsInput.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import Button from "@mui/material/Button";
import ButtonWithIcon from "components/CustomButtons/Button";
import { makeStyles, withStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import sweetAlertStyle from "../../assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "../../services/UserService";
import useEntitesTable from "./useEntitesTable.js";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import { getExport, getFiles, getExportParseFile, getChartList } from "../../services/ConfigServices";
import styled from "styled-components";
import {
  typeData, recurrenceData, paramTypeDataTemplate, paramTypeDataExport, paramTypeIndicPeriod,
  paramTypeAlertValueData, paramTypeIndicValueData, formatData, periodData, formatDatase60,
  paramTypePatrimoineValueData, paramTypeMapsValueData, paramTypeActionPlanValueData, duplicateData, templateIndicSize
} from "variables/lists/exports";
import Divider from "@mui/material/Divider";
import AdvancedSearch from "./AdvancedSearch";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);


const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 300,
    marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  smallgriditem: {
    padding: "0px !important",
  },
  removeitem: {
    padding: "20px 0 0 0 !important",
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "25px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "25px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  formControlLabel:
  {
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '14px',
    '& .MuiFormControlLabel-label': {
      fontFamily: '"Source Sans Pro",sans-serif',
      fontSize: '14px',
    }
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

const emailPattern = new RegExp(
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i
);

function EditExportDialog(props) {
  const currentusertype = localStorage.getItem('userType');
  const { closeModal, refetch, setLoading, setNotification } = props;
  const appContext = useContext(AdvancedSearchContext);
  const memv2versionactive = localStorage.getItem("memv2version") || 0;
  const { chartIdGroup } = appContext;
  const [name, setName] = React.useState(props.parameters.name);
  const [format, setFormat] = React.useState(props.parameters.format);
  const [type, setType] = React.useState(props.parameters.type);
  const [recurrence, setRecurrence] = React.useState(props.parameters.recurrence);
  const [period, setPeriod] = React.useState(props.parameters.period);
  const [datebegin, setDatebegin] = React.useState(props.parameters.datebegin);
  const [dateend, setDateend] = React.useState(props.parameters.dateend);
  const [duplicate, setDuplicate] = React.useState(props.parameters.duplicate);
  const [template, setTemplate] = React.useState(props.parameters.template);
  const [diffusion, setDiffusion] = React.useState(props.parameters.diffusion);
  const [groups, setGroups] = React.useState(props.parameters.groups);
  const [contentparam, setContentparam] = React.useState(props.parameters.contentparam);
  const [filterType, setFilterType] = useState(props.parameters.filterType);
  const [active, setActive] = useState(props.parameters.active);
  const [filters, setFilters] = useState(props.parameters.filters);
  const [gedList, setGedList] = useState([]);
  const [chartsList, setChartsList] = useState([{ name: String, id: Number }]);
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const [value, setValue] = useState("0");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleNameChange = (event) => { 
    let n = event.target.value;
    if(n)
      n = n.replaceAll('\\', '');
    setName(n); 
  };
  const handleFormatChange = (event) => {
    setContentparam([]);
    setDuplicate("no");
    setTemplate("");
    setFormat(event.target.value);
  };
  const handleTypeChange = (event) => { setType(event.target.value); };
  const handleRecurrenceChange = (event) => { setRecurrence(event.target.value); };
  const handlePeriodChange = (event) => { setPeriod(event.target.value); };
  const handleDatebeginChange = (event) => { setDatebegin(event.target.value); };
  const handleDateendChange = (event) => { setDateend(event.target.value); };
  const handleDuplicateChange = (event) => { setDuplicate(event.target.value); };
  const handleDiffusionChange = (newValue) => {
    setDiffusion(newValue);
  };
  const handleTemplateChange = (newValue) => {
    setTemplate(newValue);
    if (newValue) {
      axios
        .get(
          getExportParseFile(newValue.fileId),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          setContentparam(res.data);
        });
    }
  };
  const handleGroupsChange = (event) => { setGroups(event.target.value); };


  const handleContentParamNameChange = (newvalue, index) => {
    const newContentParams = [...contentparam];
    newContentParams[index] = {
      ...contentparam[index],
      name: newvalue,
    };
    setContentparam(newContentParams);
  }
  const handleContentParamTypeChange = (newvalue, index) => {
    const newContentParams = [...contentparam];
    newContentParams[index] = {
      ...contentparam[index],
      type: newvalue,
      value: '',
      imagesize: '',
    };
    setContentparam(newContentParams);
  }
  const handleContentParamPeriodChange = (newvalue, index) => {
    const newContentParams = [...contentparam];
    newContentParams[index] = {
      ...contentparam[index],
      period: newvalue,
    };
    setContentparam(newContentParams);
  }
  const handleContentParamDateBeginChange = (newvalue, index) => {
    const newContentParams = [...contentparam];
    newContentParams[index] = {
      ...contentparam[index],
      datebegin: newvalue,
    };
    setContentparam(newContentParams);
  }
  const handleContentParamDateEndChange = (newvalue, index) => {
    const newContentParams = [...contentparam];
    newContentParams[index] = {
      ...contentparam[index],
      dateend: newvalue,
    };
    setContentparam(newContentParams);
  }
  const handleContentParamValueChange = (newvalue, index) => {
    const newContentParams = [...contentparam];
    newContentParams[index] = {
      ...contentparam[index],
      value: newvalue,
    };
    setContentparam(newContentParams);
  }
  const handleContentParamImageSizeChange = (newvalue, index) => {
    const newContentParams = [...contentparam];
    newContentParams[index] = {
      ...contentparam[index],
      imagesize: newvalue,
    };
    setContentparam(newContentParams);
  }

  const removeCondition = (index) => {
    const newContentParams = [...contentparam];
    newContentParams.splice(index, 1);
    setContentparam(newContentParams);
  };

  const handleFiltersChange = (val) => {
    setFilters(val);
  };

  const classes = useStyles();

  const selectedGed = () => {
    let selected;
    if (template) {
      selected = template;
    }
    return selected;
  };

  const handleSubmit = (event) => {
    updateExport(event);
    setLoading(true);
    closeModal();
  };

  const addExcelTab = () => {
    const newContentParams = [...contentparam];
    let size = contentparam.length;
    size = size + 1;
    const newparam = { name: 'Feuil' + size, type: '', period: 'same', value: '' };
    newContentParams.push(newparam);
    setContentparam(newContentParams);
  };

  const getIndicSelected = (indicid) => {
    let indic = chartsList.find((chart) => chart.id === indicid);
    if (!indic)
      indic = {};
    return indic;
  }

  useEffect(() => {
    axios
      .get(
        getFiles(chartIdGroup, "docx"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        if (res.data?.status && res.data.status === 'ok')
          setGedList(res.data.collection);
        else
          setGedList([]);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        getChartList(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        let chartlistmp = [];
        if (res.data) {
          Object.keys(res.data).forEach(function (key) {
            if (res.data[key].version && res.data[key].version === 'v2')
              chartlistmp.push({ id: 'v2' + key, name: res.data[key].name });
            else
              chartlistmp.push({ id: key, name: res.data[key].name });
          });
        }
        setChartsList(chartlistmp);
      });
  }, []);

  useEffect(() => {
    if (!name || groups.length == 0 || (format === 'docx' && !template) || (period === 'datechoice' && (!datebegin || !dateend)))
      setButtonDisabled(true);
    else
      setButtonDisabled(false);

  }, [name, format, template, groups, datebegin, dateend, period]);

  const updateExport = async (event) => {
    axios
      .put(
        getExport(props.id),
        {
          name,
          format,
          type,
          recurrence,
          period,
          datebegin,
          dateend,
          template,
          diffusion,
          groups,
          contentparam,
          filters,
          active,
          filterType,
          duplicate,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          setNotification("success", "Export modifié");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        setLoading(false);
      });
  };

  return (
    <TabContext value={value} className={classes.root}>
      <div className={classes.demo2}>
        <AppBar
          position="static"
          className={classes.demo3}
          style={{ boxShadow: "none", shadowColor: "red" }}
        >
          <StyledTabs
            value={value}
            onChange={handleChange}
            aria-label="styled tabs example"
            scrollButtons="auto"
          >
            <StyledTab label="Paramètres généraux" value="0" />
            <StyledTab label="Filtres" value="1" />
          </StyledTabs>
          <Typography className={classes.padding} />
        </AppBar>
        <Divider variant="fullWidth" />
        <TabPanel value="0" style={{ marginBottom: "-35px" }}>
          <form className={classes.root}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <GridContainer>
                  <GridItem xs={12} sm={6} md={7} lg={7}>
                    <div>
                      <TextInput
                        inputTitle={"Nom"}
                        textInput={name}
                        handleTextInputChange={handleNameChange}
                      />
                    </div>

                    <div>
                      <CustomSelect
                        inputTitle={"Format"}
                        selectValue={format}
                        handleSelectValueChange={handleFormatChange}
                        data={(currentusertype == 1 || UserService.getEmail().endsWith('@se60.fr')) ? formatDatase60 : formatData}
                      />
                    </div>
                    <div>
                      <CustomSelect
                        inputTitle={"Type"}
                        selectValue={type}
                        handleSelectValueChange={handleTypeChange}
                        data={typeData}
                      />
                    </div>
                    {type === 1 ?
                      <div>
                        <CustomSelect
                          inputTitle={"Récurrence"}
                          selectValue={recurrence}
                          handleSelectValueChange={handleRecurrenceChange}
                          data={recurrenceData}
                        />
                      </div> : <></>
                    }

                    <div>
                      <CustomSelect
                        inputTitle={"Période du rapport"}
                        selectValue={period}
                        handleSelectValueChange={handlePeriodChange}
                        data={periodData}
                      />
                    </div>
                    {
                      period === 'datechoice' &&
                      <><div>
                        <DateInput
                          inputTitle={"Date de début"}
                          dateInput={datebegin}
                          handleDateInputChange={handleDatebeginChange}
                          isRequired={true}
                        />
                      </div>
                        <div>
                          <DateInput
                            inputTitle={"Date de fin"}
                            dateInput={dateend}
                            handleDateInputChange={handleDateendChange}
                            isRequired={true}
                          />
                        </div>
                      </>
                    }
                    {format === 'docx' ?
                      <div>
                        <CustomSelect
                          inputTitle={"Duppliquer le rapport"}
                          selectValue={duplicate}
                          handleSelectValueChange={handleDuplicateChange}
                          data={duplicateData}
                        />
                      </div> : <></>
                    }
                    <div>
                      <AutocompleteTagsInput
                        specialWidth={"97%"}
                        inputTitle={"Diffusion"}
                        list={[]}
                        selected={diffusion}
                        handleChange={handleDiffusionChange}
                      />
                    </div>
                    {(format === 'docx' || format === 'se60docx') ?
                      <div>
                        <AutocompleteInput
                          isMultiple={false}
                          specialWidth={"97%"}
                          inputTitle={"Template"}
                          selected={selectedGed()}
                          list={gedList}
                          handleChange={(_, newValue) =>
                            handleTemplateChange(newValue)
                          }
                        />
                      </div> : <></>
                    }
                  </GridItem>
                  <GridItem xs={12} sm={6} md={5} lg={5}>
                    <div
                      className={classes.treeVisible}
                    >
                      <TreeLabel>Choix du périmètre</TreeLabel>
                      <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                        <EmbeddedEntitesTree
                          selectedIds={setGroups}
                          userSelectedIds={groups}
                        />
                      </ImageList>
                    </div>
                  </GridItem>
                </GridContainer>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} lg={12} className={classes.smallgriditem}>
                <GridContainer>
                  {format === 'docx' ?

                    contentparam.map((param, index) => {
                      let paramindex = index + 1;
                      return (
                        <GridItem xs={12} sm={12} md={12} lg={12} className={classes.smallgriditem}>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                              <div>
                                <CustomSelect
                                  inputTitle={"Variable " + param.name + " : type"}
                                  selectValue={param.type}
                                  handleSelectValueChange={(e) => handleContentParamTypeChange(e.target.value,
                                    index)}
                                  data={paramTypeDataTemplate}
                                />
                              </div>
                            </GridItem>
                            {param.type !== 'patrimoine' ?
                              <>
                                <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                  <div>
                                    <CustomSelect
                                      inputTitle={"Variable " + param.name + " : période"}
                                      selectValue={param.period}
                                      handleSelectValueChange={(e) => handleContentParamPeriodChange(e.target.value,
                                        index)}
                                      data={paramTypeIndicPeriod}
                                    />
                                  </div>
                                </GridItem>
                                {
                                  param.period === 'datechoice' &&
                                  <>
                                    <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                      <div>
                                        <DateInput
                                          inputTitle={"Début"}
                                          dateInput={param.datebegin}
                                          handleDateInputChange={(e) => handleContentParamDateBeginChange(e.target.value,
                                            index)}
                                          isRequired={true}
                                        />
                                      </div>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                      <div>
                                        <DateInput
                                          inputTitle={"Fin"}
                                          dateInput={param.dateend}
                                          handleDateInputChange={(e) => handleContentParamDateEndChange(e.target.value,
                                            index)}
                                          isRequired={true}
                                        />
                                      </div>
                                    </GridItem>
                                  </>
                                }
                              </> : <></>
                            }

                            {param.type === 'indic' ?
                              <>
                                <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                  <div>
                                    <AutocompleteInputMeters
                                      specialWidth={"94%"}
                                      inputMargin={"1rem 0rem 0rem"}
                                      inputTitle={"Variable " + param.name + " : indicateur"}
                                      selected={getIndicSelected(param.value)}
                                      list={chartsList}
                                      handleChange={(_, newValue) => handleContentParamValueChange(newValue.id,
                                        index)}
                                    />
                                    {/* <CustomSelect
                                      inputTitle={"Variable " + param.name + " : indicateur"}
                                      selectValue={param.value}
                                      handleSelectValueChange={(e) => handleContentParamValueChange(e.target.value,
                                        index)}
                                      data={chartsList}
                                    /> */}
                                  </div>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                  <div>
                                    <CustomSelect
                                      inputTitle={"Variable " + param.name + " : taille"}
                                      selectValue={param.imagesize}
                                      handleSelectValueChange={(e) => handleContentParamImageSizeChange(e.target.value,
                                        index)}
                                      data={templateIndicSize}
                                    />
                                  </div>
                                </GridItem>
                              </>
                              : param.type === 'alert' ? <>
                                <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                  <div>
                                    <CustomSelect
                                      inputTitle={"Variable " + param.name + " : filtres"}
                                      selectValue={param.value}
                                      handleSelectValueChange={(e) => handleContentParamValueChange(e.target.value,
                                        index)}
                                      data={paramTypeAlertValueData}
                                    />
                                  </div>
                                </GridItem>
                              </> : param.type === 'maps' ? <>
                                <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                  <div>
                                    <CustomSelect
                                      inputTitle={"Variable " + param.name + " : filtres"}
                                      selectValue={param.value}
                                      handleSelectValueChange={(e) => handleContentParamValueChange(e.target.value,
                                        index)}
                                      data={paramTypeMapsValueData}
                                    />
                                  </div>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                  <div>
                                    <CustomSelect
                                      inputTitle={"Variable " + param.name + " : taille"}
                                      selectValue={param.imagesize}
                                      handleSelectValueChange={(e) => handleContentParamImageSizeChange(e.target.value,
                                        index)}
                                      data={templateIndicSize}
                                    />
                                  </div>
                                </GridItem>
                              </> : param.type === 'patrimoine' ? <>
                                <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                  <div>
                                    <CustomSelect
                                      inputTitle={"Variable " + param.name + " : filtres"}
                                      selectValue={param.value}
                                      handleSelectValueChange={(e) => handleContentParamValueChange(e.target.value,
                                        index)}
                                      data={paramTypePatrimoineValueData}
                                    />
                                  </div>
                                </GridItem>
                              </> : param.type === 'actionplan' ? <>
                                <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                  <div>
                                    <CustomSelect
                                      inputTitle={"Variable " + param.name + " : filtres"}
                                      selectValue={param.value}
                                      handleSelectValueChange={(e) => handleContentParamValueChange(e.target.value,
                                        index)}
                                      data={paramTypeActionPlanValueData}
                                    />
                                  </div>
                                </GridItem>
                              </> : (param.type === 'event' || param.type === 'eventdetailed') ? <>
                                <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                  <div>
                                    <TextInput
                                      inputTitle={"Filtre de catégorie (contient)"}
                                      textInput={param.value}
                                      handleTextInputChange={(e) => handleContentParamValueChange(e.target.value,
                                        index)}

                                    />
                                  </div>
                                </GridItem>
                              </> : param.type === 'turpe' ? <>
                                {/* <GridItem xs={12} sm={12} md={3} lg={3} className={classes.smallgriditem}> 
                                  <div>
                                    <CustomSelect
                                      inputTitle={"Onglet " + paramindex + " : filtres"}
                                      selectValue={param.value}
                                      handleSelectValueChange={(e) => handleContentParamValueChange(e.target.value,
                                        index)}
                                      data={paramTypeAlertValueData}
                                    />
                                  </div>
                                </GridItem> */}</>
                                : <></>
                            }

                          </GridContainer>
                        </GridItem>
                      );
                    }) : format === 'xlsx' ?


                      contentparam.map((param, index) => {
                        let paramindex = index + 1;
                        return (
                          <GridItem xs={12} sm={12} md={12} lg={12} className={classes.smallgriditem}>
                            <GridContainer>
                              <GridItem xs={11} sm={11} md={2} lg={2} className={classes.smallgriditem}>
                                <div>
                                  <TextInput
                                    inputTitle={"Onglet " + paramindex + " : Nom"}
                                    textInput={param.name}
                                    handleTextInputChange={(e) => handleContentParamNameChange(e.target.value,
                                      index)}
                                  />
                                </div>
                              </GridItem>
                              <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                <div>
                                  <CustomSelect
                                    inputTitle={"Onglet " + paramindex + " : type"}
                                    selectValue={param.type}
                                    handleSelectValueChange={(e) => handleContentParamTypeChange(e.target.value,
                                      index)}
                                    data={paramTypeDataExport}
                                  />
                                </div>
                              </GridItem>
                              {param.type !== 'patrimoine' && param.type !== 'turpe' ?
                                <>
                                  <GridItem xs={12} sm={12} md={param.period === 'datechoice' ? 1 : 2} lg={param.period === 'datechoice' ? 1 : 2} className={classes.smallgriditem}>
                                    <div>
                                      <CustomSelect
                                        inputTitle={"Onglet " + paramindex + " : période"}
                                        selectValue={param.period}
                                        handleSelectValueChange={(e) => handleContentParamPeriodChange(e.target.value,
                                          index)}
                                        data={paramTypeIndicPeriod}
                                      />
                                    </div>
                                  </GridItem>
                                  {
                                    param.period === 'datechoice' &&
                                    <>
                                      <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                        <div>
                                          <DateInput
                                            inputTitle={"Début"}
                                            dateInput={param.datebegin}
                                            handleDateInputChange={(e) => handleContentParamDateBeginChange(e.target.value,
                                              index)}
                                            isRequired={true}
                                          />
                                        </div>
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                        <div>
                                          <DateInput
                                            inputTitle={"Fin"}
                                            dateInput={param.dateend}
                                            handleDateInputChange={(e) => handleContentParamDateEndChange(e.target.value,
                                              index)}
                                            isRequired={true}
                                          />
                                        </div>
                                      </GridItem>
                                    </>
                                  }
                                </> : <></>
                              }

                              {param.type === 'indic' ?
                                <>
                                  <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                    <div>
                                      <AutocompleteInputMeters
                                        specialWidth={"94%"}
                                        inputMargin={"1rem 0rem 0rem"}
                                        inputTitle={"Variable " + param.name + " : indicateur"}
                                        selected={getIndicSelected(param.value)}
                                        list={chartsList}
                                        handleChange={(_, newValue) => handleContentParamValueChange(newValue.id,
                                          index)}
                                      />
                                      {/* <CustomSelect
                                        inputTitle={"Onglet " + paramindex + " : indicateur"}
                                        selectValue={param.value}
                                        handleSelectValueChange={(e) => handleContentParamValueChange(e.target.value,
                                          index)}
                                        data={chartsList}
                                      /> */}
                                    </div>
                                  </GridItem>
                                </>
                                : param.type === 'alert' ? <>
                                  <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                    <div>
                                      <CustomSelect
                                        inputTitle={"Onglet " + paramindex + " : filtres"}
                                        selectValue={param.value}
                                        handleSelectValueChange={(e) => handleContentParamValueChange(e.target.value,
                                          index)}
                                        data={paramTypeAlertValueData}
                                      />
                                    </div>
                                  </GridItem>
                                </> : param.type === 'maps' ? <>
                                  <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                    <div>
                                      <CustomSelect
                                        inputTitle={"Onglet " + paramindex + " : filtres"}
                                        selectValue={param.value}
                                        handleSelectValueChange={(e) => handleContentParamValueChange(e.target.value,
                                          index)}
                                        data={paramTypeMapsValueData}
                                      />
                                    </div>
                                  </GridItem>
                                </> : param.type === 'patrimoine' ? <>
                                  <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                    <div>
                                      <CustomSelect
                                        inputTitle={"Onglet " + paramindex + " : filtres"}
                                        selectValue={param.value}
                                        handleSelectValueChange={(e) => handleContentParamValueChange(e.target.value,
                                          index)}
                                        data={paramTypePatrimoineValueData}
                                      />
                                    </div>
                                  </GridItem>
                                </> : param.type === 'actionplan' ? <>
                                  <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                    <div>
                                      <CustomSelect
                                        inputTitle={"Onglet " + paramindex + " : filtres"}
                                        selectValue={param.value}
                                        handleSelectValueChange={(e) => handleContentParamValueChange(e.target.value,
                                          index)}
                                        data={paramTypeActionPlanValueData}
                                      />
                                    </div>
                                  </GridItem>
                                </> : (param.type === 'event' || param.type === 'eventdetailed') ? <>
                                  <GridItem xs={12} sm={12} md={2} lg={2} className={classes.smallgriditem}>
                                    <div>
                                      <TextInput
                                        inputTitle={"Filtre de catégorie (contient)"}
                                        textInput={param.value}
                                        handleTextInputChange={(e) => handleContentParamValueChange(e.target.value,
                                          index)}

                                      />
                                    </div>
                                  </GridItem>
                                </> : param.type === 'turpe' ? <>
                                  {/* <GridItem xs={12} sm={12} md={3} lg={3} className={classes.smallgriditem}> 
                                  <div>
                                    <CustomSelect
                                      inputTitle={"Onglet " + paramindex + " : filtres"}
                                      selectValue={param.value}
                                      handleSelectValueChange={(e) => handleContentParamValueChange(e.target.value,
                                        index)}
                                      data={paramTypeAlertValueData}
                                    />
                                  </div>
                                </GridItem> */}
                                </> : <></>
                              }
                              <GridItem xs={1} sm={1} md={1} lg={1} className={classes.removeitem}>
                                <FormControlLabel
                                  className={classes.formControlLabel}
                                  value="remove"
                                  control={
                                    <ButtonWithIcon
                                      type="button"
                                      round color="transparent" justIcon
                                      size={"sm"}
                                      onClick={() => removeCondition(index)}
                                    >
                                      <RemoveCircleOutline> </RemoveCircleOutline>
                                    </ButtonWithIcon>
                                  }
                                  labelPlacement="start"
                                  label={''}
                                />
                              </GridItem>
                            </GridContainer>
                          </GridItem>
                        );
                      })


                      : <></>
                  }

                </GridContainer>
              </GridItem>
              {format === 'xlsx' &&
                <GridItem xs={12} sm={12} md={6} lg={6}>
                  <FormControlLabel
                    value="addExcelTab"
                    className={classes.formControlLabel}
                    control={
                      <ButtonWithIcon
                        type="button" round
                        color="transparent"
                        justIcon size={"sm"}
                        onClick={addExcelTab}
                      >
                        <AddCircleOutline> </AddCircleOutline>
                      </ButtonWithIcon>
                    }
                    label=" Ajouter un onglet "
                  />
                </GridItem>
              }

            </GridContainer>
          </form>
        </TabPanel>
        <TabPanel value="1">
          <AdvancedSearch
            filters={filters}
            handleFiltersChange={handleFiltersChange}
            active={active}
            setActive={setActive}
            type={filterType}
            setType={setFilterType}
          ></AdvancedSearch>
        </TabPanel>
      </div>
      <Button
        disabled={buttonDisabled}
        className={
          buttonDisabled
            ? classes.submitButtonDisabled
            : classes.submitButton
        }
        onClick={() => {
          handleSubmit();
        }}
      >
        Modifier
      </Button>
    </TabContext>
  );
}

export default EditExportDialog;
